import React from "react";

const SearchIcon = (props: any) => {
  return (
   <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} className="w-[28px] h-[28px] mx-[2px] my-[2px]">
<path d="M20.417 20.418L25.667 25.668" stroke="#747474" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M23.333 12.832C23.333 7.03304 18.632 2.33203 12.833 2.33203C7.03402 2.33203 2.33301 7.03304 2.33301 12.832C2.33301 18.631 7.03402 23.332 12.833 23.332C18.632 23.332 23.333 18.631 23.333 12.832Z" stroke="#747474" stroke-width="1.5" stroke-linejoin="round"/>
</svg>

  );
};

export default SearchIcon;
